import styled from '@emotion/styled';
import { getRecruitmentBadges, type BadgeStyle, type RecruitmentBadgeInfo } from './RecruitmentGrid';

/**
 * 썸네일이 없는 글 목록용 채용 배지 — 홈 지역 목록(병원명 옆), 통합 검색 채용 결과(제목 앞).
 * 조건·우선순위·색은 썸네일 배지와 같은 `getRecruitmentBadges` 하나를 쓴다(모집종료 → 급구 → 종료임박 → 신규 → 상시모집, 하나만).
 */
const Badge = styled.span`
    display: inline-block;
    flex-shrink: 0;
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    vertical-align: middle;
`;

const RecruitmentInlineBadge = ({ info, className }: { info: RecruitmentBadgeInfo; className?: string }) => {
    const badge: BadgeStyle | undefined = getRecruitmentBadges(info)[0];
    return badge ? <Badge className={className} data-recruitment-badge style={{ background: badge.bg, color: badge.color }}>{badge.label}</Badge> : null;
};

export default RecruitmentInlineBadge;
